const API_URL = process.env.REACT_APP_API_URL;

export const api = {
	user: {
		login: `${API_URL}student-login/studentLogin`,
		landingMedia: `${API_URL}student-login/LandingPageMedia`,
		profileAvatar: `${API_URL}student-login/fetchProfileAvatar`,
		signup: `${API_URL}student-login/studentSign-up`,
		fetchFavactivities: `${API_URL}favorite-activities/favoriteActivities`,
		updateFavactivities: `${API_URL}student-login/FavoriteActivitiesString`,
		fetchTermsandConditions: `${API_URL}student-login/GetPopMessageBasedOnPopupType`,
		updateTermsandConditions: `${API_URL}student-login/TermsandCondition_screens`,
		collectCoin: `${API_URL}capture-coin/insertT_C_CoinFlagImage`,
	},
	chatmessage: {
		fetchChat: `${API_URL}chat-messages/getchatmessages`,
		sendChat: `${API_URL}chat-messages/postchatmessages`,
		fetchStudentsList: `${API_URL}chat-messages/getallstudents`,
		blockedStatus: `${API_URL}chat-messages/getstudentBlockStatus`,
	},
	blockedword: {
		fecthBlockedwords: `${API_URL}chat-blocked-words/getchatblockedwords`
	},
	chatmonitoring: {
		reportChat: `${API_URL}chat-monitoring/Report_Chat_Message`,
	},
	myprofile: {
		fetchmyprofile: `${API_URL}myprofile/StudentProfileID`,
		updateavatar: `${API_URL}myprofile/updateavatar`,
		updatemyprofile: `${API_URL}myprofile/updatestudentprofile`,
		fetchmypoints: `${API_URL}capture-coin/GameMyPoints`,
		fetchscoreboard: `${API_URL}capture-coin/GetAllScoreBoard`,
		purchaseAvatar: `${API_URL}student-login/purchaseProfileAvatar`,
	},
	games: {
		fetchgames: `${API_URL}game-maintenance/FetchGamesforStudent`,
		fetchQuestion: `${API_URL}game-maintenance/Questions`,
		fetchCoinImage: `${API_URL}capture-coin/fetchCoinFlagImage`,
		submitAns: `${API_URL}game-maintenance/insertAnsersForGameQuestion`,
		captureCoin: `${API_URL}game-maintenance/InsertCoinImageforQuestion`,
		purchaseGame: `${API_URL}game-maintenance/purchaseGame`,
	},
	config: {
		fetchAppconfigs: `${API_URL}configuration/getconfiguration`,
		fetchFontDetails: `${API_URL}game-fonts/getGameFontsforGame`,
	},
	admessage: {
		fetchAdmessage: `${API_URL}ad-messages/getAdmessageforGame`,
		submitAdmessage: `${API_URL}ad-messages/submitAdmessageForm`,
	},
	organization: {
		getBranding: `${API_URL}organization/branding`,
	},
};